/**
 * @Description: 客户分组/模型/版本 共用的 axios 实例
 * 基础路径：/sphere-admin/api/v1/sphere/...
 * 认证方式：请求头携带 Authorization: Bearer <token>（门户 eiip_access_token，与 /base 路径鉴权一致）
 */
import axios from 'axios'
import { getToken } from '@/utils/auth'

/**
 * 查询参数序列化：空值跳过，数组展开为重复键（无 [] 后缀），兼容 Spring 后端 List 参数绑定
 */
function serializeParams(params) {
  const search = new URLSearchParams()
  Object.keys(params || {}).forEach((key) => {
    const value = params[key]
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          search.append(key, item)
        }
      })
    } else {
      search.append(key, value)
    }
  })
  return search.toString()
}

const request = axios.create({
  timeout: 50000,
  withCredentials: false,
  paramsSerializer: serializeParams
})

request.interceptors.request.use((config) => {
  const token = getToken()
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

request.interceptors.response.use(
  (response) => {
    const res = response.data
    // 部分接口直接返回 MyBatis-Plus 分页结构（无 code 字段），可通过配置跳过统一 code 校验
    if (
      response.config.skipResponseCodeCheck ||
      res.code === 200 ||
      res.code === '200' ||
      res.code === 0 ||
      res.status_code === 200
    ) {
      return res
    }
    const msg = res.msg || res.message || '请求失败'
    return Promise.reject(new Error(msg))
  },
  (error) => {
    const msg =
      error?.response?.data?.msg ||
      error?.response?.data?.message ||
      error.message ||
      '网络请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default request
